import baseStoreDefaults from '../asfir-4x4/config.js';

export default {
  ...baseStoreDefaults,
  includes: ['shopify-warehouse-generic', 'asfir-4x4'],
  Widgets: [
    ...baseStoreDefaults.Widgets.filter(
      (w) => !['DesktopFitmentTable', 'MobileFitmentTable'].includes(w.name),
    ),
    {
      name: 'DesktopFitmentTable',
      type: 'FitmentTable',
      location: '.product-info-grid__left #cm-fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'MobileFitmentTable',
      type: 'FitmentTable',
      location: '.product-info-grid__right .product-info-blocks-wrapper #cm-fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
  ],
};

function fieldMapToString(fieldMap, fieldsOrder) {
  // Use RLM (Right-to-Left Mark) between words to force RTL ordering
  // This prevents BiDi algorithm from grouping LTR text (like "F-150 2023") together
  const RLM = '\u200F';
  return fieldsOrder
    .filter((f) => fieldMap?.[f])
    .map((f) => fieldMap[f])
    .join(` ${RLM}`);
}

window.Convermax.customVehicleString = (vehicle) => {
  return fieldMapToString(vehicle, ['Make', 'Model', 'Submodel', 'Year']);
};
